import '../../css/common.css'
import SouthDronographer from './articles/south_dronographer';
import Flickr from './articles/flickr';

let online_es = (<div>
    Tengo más hobbies de los que puedo mantener. Intento hacer siempre cosas interesantes, y a veces me sale algo bueno.
    El problema, por supuesto, es que la dispersión no apoya. De todos modos, mis actividades favoritas se pueden encontra acá.
</div>);

let online_en = (<div>
    I have more hobbies than I can maintain. I try to always do interesting things, and sometimes I get something good.
    The problem, of course, is that dispersion doesn't help. Anyway, my favorite activities can be found here.
</div>);



let online = online_es;

export function Hobbies(props){

    const lang = props.lang;

    switch(lang){
        case "en":
            online = online_en;
            break;
        case "es":
        default:
            online = online_es;
            break;
    }

    let text_structure = (
        <div>
            <p>{online}</p>
            <div className='bigDiv'><Flickr lang={lang}/></div>
            <div className='medDiv'><SouthDronographer lang={lang}/></div>
        </div>
    );

    return(<div>{text_structure}</div>);
}